import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryLight, space6, space4, space10, space12, space20, colorTextMedium } = theme();

  return StyleSheet.create({
    centeredContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "space-around",
    },
    desktopBottomList: {
      marginTop: space6,
    },
    desktopInfobox: {
      marginBottom: space12,
    },
    desktopLayout: {
      backgroundColor: colorBgPrimaryLight,
    },
    emptyStateContainer: {
      flexGrow: 1,
    },
    emptyStateWrapper: {
      flexGrow: 1,
    },
    emptyWishlistMessage: {
      alignItems: "flex-start",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
    },
    emptyWishlistMessageBody: {
      color: colorTextMedium,
      marginVertical: space4,
    },
    emptyWishlistMessageButton: {
      alignSelf: "flex-start",
    },
    emptyWishlistMessageLarge: {
      paddingVertical: space20,
    },
    emptyWishlistMessageSmall: {
      padding: space6,
      paddingVertical: space10,
    },
    mobileInfobox: {
      marginHorizontal: space6,
      marginTop: space6,
    },
    moduleWrapper: {
      width: "100%",
    },
  });
};

export { style };
